<template>
  <div
    class="image-placeholder image-placeholder--is-animate"
    ref="imageEl"
    :class="[{'image-placeholder--mod-fixed': fixed},{'image-placeholder--is-loaded': isLoaded}]"
    v-bind:style="bgImage"
    @contextmenu.prevent="preventRightClick"
  />
</template>
<script>
import imagesLoaded from 'imagesloaded'
import getTypeClass from '../../utils/getTypeClass'
import parsePlaceholder from '../../utils/parsePlaceholder'
export default {
  name: 'ImagePlaceholder',
  data () {
    return {
      maxSize: 300
    }
  },
  props: {
    isLoaded: Boolean,
    imageData: Object,
    url: String,
    displayType: {
      type: String,
      default: 'cover'
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkImageLoad () {
      const imgLoad = imagesLoaded(this.$refs.imageEl, {background: true})
      const onDone = (instance) => {
        this.setIsLoaded()
        imgLoad.off('done', onDone)
      }
      imgLoad.on('done', onDone)
    },
    setIsLoaded () {
      this.$nextTick(_ => {
        this.$emit('imageLoaded', true)
      })
    },
    preventRightClick () {
      return false
    }
  },
  computed: {
    imgSrc: function () {
      let src = null
      if (this.imageData) {
        src = parsePlaceholder(this.imageData)
      }
      if (!src) {
        src = this.url
      }
      return src
    },
    bgImage: function () {
      return { backgroundImage: `url(${this.imgSrc})` }
    },
    imagePlaceholderClass () {
      return `image-placeholder${getTypeClass(this.displayType)}`
    }
  },
  mounted () {
    if (this.imgSrc) {
      this.checkImageLoad()
    } else {
      this.setIsLoaded()
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './image-placeholder.scss'
</style>



// WEBPACK FOOTER //
// src/modules/ModuleImage/components/ImagePlaceholder/ImagePlaceholder.vue